// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__xGR6q","paramInput":"JobSimulator_paramInput__3IMxK","input":"JobSimulator_input__2SOTA"};